import common from './common/index';
import auth, {
  getters as authGetters,
  actions as authActions,
  types as authTypes,
  mapState as authMapState,
  mapGetters as authMapGetters,
  mapActions as authMapActions,
} from '../../lib/auth/store';
import user from './user/index';
import review from './review';
import area from './area';
import board from './board';
import keyword from './keyword';
import estimate from './estimate';
import shop from './shop';
import xeronote from './xeronote';
import chat from './chat';
import dashboard from './dashboard';
import booking from './booking';
import internet from './internet';
import safeNumber from './safeNumber';
import address from './address';
import mobile from './mobile';
import community from './community';
import banner from './banner';
import search from './search';
import product from './product';
import promotion from './promotion';
import message from './message';

export {
  common,
  auth,
  user,
  review,
  area,
  board,
  keyword,
  estimate,
  shop,
  xeronote,
  chat,
  dashboard,
  booking,
  internet,
  safeNumber,
  address,
  mobile,
  community,
  banner,
  search,
  product,
  promotion,
  message,
};

export {
  authGetters,
  authActions,
  authTypes,
  authMapState,
  authMapGetters,
  authMapActions,
};
